export let data = {
    "map": {
        "ADA4351-2": "ADA4351-2",
    },
    "partData": {
        "ADA4351-2": {
            outputArchitecture: "Kelvin Switching",
            cF: 3e-12,
            rKelvin: 13
        }
    }
}